// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
// Import Font Awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faEnvelope, faShieldHalved, faFileContract, faUniversalAccess, faLink } from '@fortawesome/free-solid-svg-icons';
import { faPinterest, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { useSafeDate } from '../utils/hydrationSafe';
import { generateCategoryUrl } from '../utils/enhancedLinkGenerators';

function Footer({ countryCode = 'usa' }) {
  // Use safe date hook to prevent hydration mismatches
  const currentDate = useSafeDate();
  const currentYear = currentDate.getFullYear();
  
  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>OriginSelect</h4>
            <p>Where local authenticity meets exceptional craftsmanship</p>
          </div>
          
          <div className="footer-section">
            <h4>Shop Categories</h4>
            <div className="category-links">
              <Link to={generateCategoryUrl(countryCode, 'Baby & Kids')} className="category-link">Baby & Kids Products</Link>
              <Link to={generateCategoryUrl(countryCode, 'Beauty')} className="category-link">Beauty</Link>
              <Link to={generateCategoryUrl(countryCode, 'Home Decor')} className="category-link">Home Decor</Link>
              <Link to={generateCategoryUrl(countryCode, 'Grocery & Gourmet Foods')} className="category-link">Grocery & Gourmet</Link>
              <Link to={generateCategoryUrl(countryCode, 'Health & Wellness')} className="category-link">Health & Wellness</Link>
              <Link to={generateCategoryUrl(countryCode, 'Clothing')} className="category-link">Clothing</Link>
              <Link to={generateCategoryUrl(countryCode, 'Beverages')} className="category-link">Beverages</Link>
              <Link to={generateCategoryUrl(countryCode, 'Books & Media')} className="category-link">Books & Media</Link>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <div className="quick-links-icons">
              <Link to={`/country/${countryCode}/about`} className="icon-link" title="About Us">
                <FontAwesomeIcon icon={faInfoCircle} className="footer-icon" />
                <span className="icon-label">About Us</span>
              </Link>
              
              <Link to={`/country/${countryCode}/contact`} className="icon-link" title="Contact">
                <FontAwesomeIcon icon={faEnvelope} className="footer-icon" />
                <span className="icon-label">Contact</span>
              </Link>
              
              <Link to={`/country/${countryCode}/resources`} className="icon-link" title="Business Resources">
                <FontAwesomeIcon icon={faLink} className="footer-icon" />
                <span className="icon-label">Business Directory</span>
              </Link>
              
              <Link to={countryCode ? `/country/${countryCode}/privacy` : '/privacy'} className="icon-link" title="Privacy Policy">
                <FontAwesomeIcon icon={faShieldHalved} className="footer-icon" />
                <span className="icon-label">Privacy Policy</span>
              </Link>
              
              <Link to={countryCode ? `/country/${countryCode}/disclaimer` : '/disclaimer'} className="icon-link" title="Disclaimer">
                <FontAwesomeIcon icon={faFileContract} className="footer-icon" />
                <span className="icon-label">Disclaimer</span>
              </Link>
              <Link to={countryCode ? `/country/${countryCode}/accessibility` : '/accessibility'} className="icon-link" title="Accessibility Statement">
                <FontAwesomeIcon icon={faUniversalAccess} className="footer-icon" />
                <span className="icon-label">Accessibility</span>
              </Link>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://www.pinterest.com/originselect_canada/" className="social-icon-link" title="Pinterest" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faPinterest} className="social-footer-icon" />
              </a>
              <a href="https://www.instagram.com/OriginSelect/" className="social-icon-link" title="Instagram" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} className="social-footer-icon" />
              </a>
              <a href="https://www.youtube.com/@OriginSelect" className="social-icon-link" title="YouTube" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faYoutube} className="social-footer-icon" />
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© {currentYear} OriginSelect. All rights reserved.</p>
          <p>
            <Link to={countryCode ? `/country/${countryCode}/privacy` : '/privacy'} className="footer-link">Privacy Policy</Link>
          </p>
          <p>
            <Link to={countryCode ? `/country/${countryCode}/disclaimer` : '/disclaimer'} className="footer-link">Disclaimer</Link>
          </p>
          <p>
            <Link to={countryCode ? `/country/${countryCode}/accessibility` : '/accessibility'} className="footer-link">Accessibility Statement</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
